module.exports = __webpack_public_path__ + "../assets/img/1064004c6fdabb3fa960647c5460755f.svg";